import { apiClient } from '@/lib/api/apiClient';

export interface LifelineDto {
  id: string;
  code: string;
  name: string;
  nameAr: string;
  description: string;
  descriptionAr: string;
  iconUrl?: string;
  iconColor?: string;
  usageTime: string;
  effect: string;
  isEnabled: boolean;
  displayOrder: number;
}

export interface GetLifelinesResponse {
  lifelines: LifelineDto[];
}

const LIFELINE_ENDPOINT = '/api/lifelines';

export const playerLifelineService = {
  /**
   * Get all enabled lifelines (for players)
   */
  async getEnabledLifelines(): Promise<LifelineDto[]> {
    try {
      const response = await apiClient.get(LIFELINE_ENDPOINT);
      return response.data.data?.lifelines || [];
    } catch (error) {
      console.error('Failed to fetch lifelines:', error);
      // Return default lifelines if API fails
      return getDefaultLifelines();
    }
  },
};

/**
 * Default lifelines as fallback
 */
function getDefaultLifelines(): LifelineDto[] {
  return [
    {
      id: 'steal-question',
      code: 'STEAL_QUESTION',
      name: 'Steal Question',
      nameAr: 'سرقة السؤال',
      description: 'Steal the question from the opponent and answer it yourself',
      descriptionAr: 'اسرق السؤال من الخصم وأجب عليه بنفسك',
      iconUrl: '/Resources/Help method/سرقة السؤال.jpeg',
      iconColor: '#8B5CF6',
      usageTime: 'AFTER_QUESTION',
      effect: 'STEAL_QUESTION',
      isEnabled: true,
      displayOrder: 1,
    },
    {
      id: 'the-pit',
      code: 'THE_PIT',
      name: 'The Pit',
      nameAr: 'الحفرة',
      description: 'If you answer correctly, deduct the same points from opponent',
      descriptionAr: 'احفرلهم! جاوب صح، واخصم عدد النقاط اللي فزت فيها من نقاط الفريق الثاني',
      iconUrl: '/Resources/Help method/الحفرة.jpeg',
      iconColor: '#F97316',
      usageTime: 'BEFORE_QUESTION',
      effect: 'DEDUCT_OPPONENT_POINTS',
      isEnabled: true,
      displayOrder: 2,
    },
    {
      id: 'double-answer',
      code: 'DOUBLE_ANSWER',
      name: 'Double Answer',
      nameAr: 'جاوب جوابين',
      description: 'Not sure? Pick two answers to secure the points',
      descriptionAr: 'متردد بجوابين؟ هذه لك، جاوب بالاثنين عشان تضمن النقاط',
      iconUrl: '/Resources/Help method/جاوب جوابين.jpeg',
      iconColor: '#3B82F6',
      usageTime: 'AFTER_QUESTION',
      effect: 'TWO_CHANCES',
      isEnabled: true,
      displayOrder: 3,
    },
    {
      id: 'silence',
      code: 'SILENCE',
      name: 'Silence Opponent',
      nameAr: 'اسكات الخصم',
      description: 'Silence an opponent and prevent them from answering',
      descriptionAr: 'اسكت خصمك! امنع أحد أعضاء الفريق المنافس من المشاركة في إجابة هالسؤال',
      iconUrl: '/Resources/Help method/اسكات الخصم.jpeg',
      iconColor: '#EF4444',
      usageTime: 'AFTER_QUESTION',
      effect: 'BLOCK_OPPONENT',
      isEnabled: true,
      displayOrder: 4,
    },
  ];
}
